import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import InlineSvg from 'components/_new/ui/InlineSvg/InlineSvg'

import s from './Icon.scss'

import appleIcon from './images/apple.svg'
import bottomArrowSmallIcon from './images/bottom-arrow-small.svg'
import checkmarkIcon from './images/checkmark.svg'
import checkmarkInCircleIcon from './images/checkmark-in-circle.svg'
import checkmarkLongIcon from './images/checkmark-long.svg'
import checkmarkLightIcon from './images/checkmark-light.svg'
import closeLightIcon from './images/close.svg'
import creditCardIcon from './images/credit-card.svg'
import dislikeIcon from './images/dislike.svg'
import facebookIcon from './images/facebook.svg'
import googleIcon from './images/google.svg'
import heartIcon from './images/heart.svg'
import infoInCircleIcon from './images/info-in-circle.svg'
import infoInCircleFilledIcon from './images/info-in-circle-filled.svg'
import leftArrowIcon from './images/left-arrow.svg'
import leftArrowSmallIcon from './images/left-arrow-small.svg'
import likeIcon from './images/like.svg'
import lockIcon from './images/lock.svg'
import paypalIcon from './images/paypal.svg'
import pencilIcon from './images/pencil.svg'
import playIcon from './images/play.svg'
import plusInCircleIcon from './images/plus-in-circle.svg'
import plusLightIcon from './images/plus-light.svg'
import questionIcon from './images/question.svg'
import replayIcon from './images/replay.svg'
import rightArrowIcon from './images/right-arrow.svg'
import rightArrowSmallIcon from './images/right-arrow-small.svg'
import searchIcon from './images/search.svg'
import timesIcon from './images/times.svg'
import truckIcon from './images/truck.svg'
import linkIcon from './images/link.svg'
import messengerIcon from './images/messenger.svg'
import smsIcon from './images/sms.svg'
import smsMessengerIcon from './images/sms-messenger.svg'
import starIcon from './images/star.svg'
// nav
import candlesIcon from './images/nav/candles.svg'
import cartIcon from './images/nav/cart.svg'
import closeIcon from './images/nav/close.svg'
import collectionsIcon from './images/nav/collections.svg'
import colognesIcon from './images/nav/colognes.svg'
import fragrancesIcon from './images/nav/fragrances.svg'
import freeIcon from './images/nav/free.svg'
import giftsIcon from './images/nav/gifts.svg'
import hamburgerIcon from './images/nav/hamburger.svg'
import helpIcon from './images/nav/help.svg'
import homeIcon from './images/nav/home.svg'
import makeupIcon from './images/nav/makeup.svg'
import perfumesIcon from './images/nav/perfumes.svg'
import personalCareIcon from './images/nav/personal-care.svg'
import profileIcon from './images/nav/profile.svg'
import queueIcon from './images/nav/queue.svg'
import skincareIcon from './images/nav/skincare.svg'
import trackingIcon from './images/nav/tracking.svg'
import wellnessIcon from './images/nav/wellness.svg'


export const icons = {
  apple: appleIcon,
  bottomArrowSmall: bottomArrowSmallIcon,
  checkmark: checkmarkIcon,
  checkmarkInCircle: checkmarkInCircleIcon,
  checkmarkLong: checkmarkLongIcon,
  checkmarkLight: checkmarkLightIcon,
  closeLight: closeLightIcon,
  creditCard: creditCardIcon,
  dislike: dislikeIcon,
  facebook: facebookIcon,
  google: googleIcon,
  heart: heartIcon,
  infoInCircle: infoInCircleIcon,
  infoInCircleFilled: infoInCircleFilledIcon,
  leftArrow: leftArrowIcon,
  leftArrowSmall: leftArrowSmallIcon,
  like: likeIcon,
  lock: lockIcon,
  paypal: paypalIcon,
  pencil: pencilIcon,
  play: playIcon,
  plusInCircle: plusInCircleIcon,
  plusLight: plusLightIcon,
  question: questionIcon,
  replay: replayIcon,
  rightArrow: rightArrowIcon,
  rightArrowSmall: rightArrowSmallIcon,
  search: searchIcon,
  times: timesIcon,
  truck: truckIcon,
  link: linkIcon,
  messenger: messengerIcon,
  sms: smsIcon,
  smsMessenger: smsMessengerIcon,
  star: starIcon,

  // nav
  candles: candlesIcon,
  cart: cartIcon,
  close: closeIcon,
  collections: collectionsIcon,
  colognes: colognesIcon,
  fragrances: fragrancesIcon,
  free: freeIcon,
  gifts: giftsIcon,
  hamburger: hamburgerIcon,
  help: helpIcon,
  home: homeIcon,
  makeup: makeupIcon,
  perfumes: perfumesIcon,
  personalCare: personalCareIcon,
  profile: profileIcon,
  queue: queueIcon,
  skincare: skincareIcon,
  tracking: trackingIcon,
  wellness: wellnessIcon,
}

const colors = [ 'black', 'brand', 'gray', 'gray-50', 'gray-70', 'green', 'white', 'error' ]

const Icon = ({ className, name, color }) => {
  if (!icons[name]) {
    console.error(`There is no icon with name "${name}"`)
  }

  const rootClassName = cx(s[name], className, {
    [s[color]]: color,
  })

  return (
    <InlineSvg className={rootClassName} src={icons[name]} cache />
  )
}

Icon.propTypes = {
  name: PropTypes.oneOf(Object.keys(icons)).isRequired,
  color: PropTypes.oneOf(colors),
}


export default Icon
